// commonFetch.js
import { useVioletBaseFetch } from "./baseFetch";

let commonFetchInstance = null;

export const useCommonFetchInit = () => {
  const baseFetch = useVioletBaseFetch();
  
  commonFetchInstance = async (url, options = {}) => {
    return baseFetch(url, options);
  };
};

export const commonFetch = async (url, options = {}) => {
  if (!commonFetchInstance) {
    throw new Error('Call useCommonFetchInit first in your app');
  }
  return commonFetchInstance(url, options);
};